import React, { useState } from 'react'
import Avatar from 'components/avatar'
import ModalHistoryTransfert from './modalHistoryTransfert'
import {logoModalTT, logoModalNety, logoModalTopnet, logoModalOoredoo, logoModalSonede,logoModalBee,logoModalSteg} from '../../assets/index'

interface Props {
  transactionData: any
  typeTransfert?: string
  isCodeVisible?:boolean
}

const ListLogo: Record<string, string>={
  'TT': logoModalTT,
  'NETY': logoModalNety,
  'STEG': logoModalSteg,
  'TOPNET': logoModalTopnet,
  'SONEDE': logoModalSonede,
  'OOREDOO': logoModalOoredoo,
  'BEE':logoModalBee ,
  's600': logoModalTopnet,
  's701' : logoModalSteg,
  's502': logoModalSonede
}

const HistoryTable: React.FC<Props> = ({ transactionData, typeTransfert, isCodeVisible=[true]  }) => {

  function formatDate(originalDate: any) {
    const dateObj = new Date(originalDate)
    const jour = dateObj.getDate()
    const mois = dateObj.getMonth() + 1
    const annee = dateObj.getFullYear()
    const jourFormatte = jour < 10 ? `0${jour}` : jour
    const moisFormatte = mois < 10 ? `0${mois}` : mois
    return `${jourFormatte}/${moisFormatte}/${annee}`
  }

  const [clickedRows, setClickedRows] = useState<boolean[]>([])

  const handleInputClick = (index: number) => {
    const newClickedRows = [...clickedRows]
    newClickedRows[index] = !newClickedRows[index]
    setClickedRows(newClickedRows)
  }
  const [infoTransfert, setInfoTransfert]= useState<any>([])
  const [openModale, setOpenModale]= useState<boolean>(false)
  const closeModalHistoryTransfert =()=>{
    setOpenModale(false)
  }
  return (
   
        <table className="table-fixed w-full text-left ">
          <thead >
              <tr className='botder-b w-full sm:text-center sm:border-none font-semibold text-[13px] text-[#AEB6FB]  lg:text-left'>
              <th className="py-2 w-[200px] 3xl:w-[130px] "> {typeTransfert ==='Facture' ? 'Opérateur': 'Bénéficiaire'} </th>
              {(typeTransfert !=='bank_account') && <th className={`${!isCodeVisible && 'hidden'} sm:hidden`}> {typeTransfert=== 'digital_wallet' ? 'Opérateur ' : typeTransfert==='Facture'? 'Référence': 'Code de retrait'}</th>}
              {typeTransfert !=='Facture' && <th className=''>Montant envoyé</th>}
              <th className="sm:hidden ">{(typeTransfert=== 'cash_pickup' ) ? 'Date' : (typeTransfert=== 'Facture' ) ? 'Montant de facture' :'Montant à recevoir' }</th>
             {(typeTransfert !=='Facture' && typeTransfert!=='bank_account') && <th className="sm:hidden"> {typeTransfert=== 'cash_pickup' ? 'Point de collecte' : 'Date'}</th>}
              <th className='w-[100px]'>Statut</th>
            </tr>
          </thead>
        <tbody className='px-2'>
          {transactionData &&
            transactionData.map((listTransaction: any, index: number) => (
              <React.Fragment key={index} >
                {/* <tbody className=''
                  key={index}
  
                  onClick={() =>{setOpenModale(true), setInfoTransfert(listTransaction)}}
                > */}
                  <tr  onClick={() =>{setOpenModale(true), setInfoTransfert(listTransaction)}}
                  className={ `${(typeTransfert==='cash_pickup' || typeTransfert==='bank_account') && 'cursor-pointer' } hover:bg-gray-100   border-b text-[#222c22] text-[14px] font-semibold w-full`}>
                    <td className={` py-2  pr-3 `} onClick={() => handleInputClick(index)}>
                      {typeTransfert !=='Facture' ?
                        <div className="flex items-center gap-3">
                          <Avatar styleCss="w-[36px] h-[36px] sm:w-[34px] sm:h-[34px] 3xl:hidden lg:block" avatar={listTransaction?.recipient?.avatar} />
                          <div className="flex flex-col ">
                              <span>
                                {listTransaction?.recipient?.personalInfo?.firstName}{' '}
                                {listTransaction?.recipient?.personalInfo?.lastName}
                              </span>
                    
                              <span className='text-[#8E8EA1] text-[11px] sm:text-[10px] lg:text-[9px] font-normal'>
                                {listTransaction?.recipient?.personalInfo?.phone?.prefix.startsWith('+')
                                ? listTransaction?.recipient?.personalInfo?.phone?.prefix
                                : `${'+'}${listTransaction?.recipient?.personalInfo?.phone?.prefix}`
  }
                                {listTransaction?.recipient?.personalInfo?.phone?.number}
                              </span>

                          </div>
                        </div>
                      :
                        <img  className='w-[40px] h-auto'
                        src={ ListLogo[listTransaction.billerCode || '']
                       
                        } alt=''/>
                      }
                    </td>
                    
                   {typeTransfert !=='bank_account' &&  
                   <td className={`${!isCodeVisible && 'hidden'} sm:hidden`}>
                      { 
                      typeTransfert=== 'Facture'
                      ?
                      listTransaction.invoiceRef
                        :typeTransfert=== 'digital_wallet'? 
                        'Orange Money'
                        :
                        listTransaction?.partnerCode  ?
                        (listTransaction?.partnerCode) 
                        :'En cours de traitement'
                        }
                        
                    
                    </td>}

                    {typeTransfert !== 'Facture' &&
                      <td className=" pl-2">
                          {Number(listTransaction?.amount?.amountToSend ).toLocaleString('fr-FR', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 3,
                          })}  
                          {` `}
                          {listTransaction?.amount?.departureCurrency?.avatar}
                      </td>
                    }
                    <td className="  sm:hidden">
                      {  (typeTransfert=== 'cash_pickup' ) 
                        ? formatDate(listTransaction?.createdAt) 
                        : ( typeTransfert=== 'Facture' )
                        ? (` ${ listTransaction.amount.amountTorecieve ?
                          Number(listTransaction.amount.amountTorecieve).toLocaleString('fr-FR', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 3,
                          })  : '__'  }  TND `)
                          
                        :(`
                          ${Number(listTransaction.amount.amountToRecieve).toLocaleString('fr-FR', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 3,
                          })}
                          ${ listTransaction.amount.destinationCurrency ? listTransaction.amount.destinationCurrency.code : ''}
                          `
                          ) 
                          }
                    </td>

                    { (typeTransfert!== 'Facture' &&  typeTransfert!=='bank_account')&&
                      <td className="pl-2 sm:hidden">
                          {typeTransfert=== 'cash_pickup' ? (listTransaction?.partner?.storeInfo?.name &&
                          listTransaction.partner?.storeInfo?.name?.length > 18
                            ? `${listTransaction.partner?.storeInfo?.name?.slice(0, 18)}...`
                            : listTransaction.partner?.storeInfo?.name)
                            : (formatDate(listTransaction?.createdAt))
                          }
                            
                      </td>
                    }
                    

                    <td className=" w-[20px] lg:w-[60px] pr-2">
                      {listTransaction?.status === 'complete' 
                      ? 
                        <div className="bg-[#EBFFF3] text-[#20C374]  flex items-center justify-center w-auto p-2 sm:p-[5px] text-[14px] sm:text-[12px]  rounded-lg">
                          {listTransaction.amount.commission===0 && listTransaction.isGift ? '0 frais' : 'Terminé'}
                        </div>
                       : listTransaction?.status=== 'in progress' || listTransaction?.status=== 'created' ? 
                        <div className="bg-[#FFDECC] text-[#FF5C00] text-center py-2 flex items-center justify-center w-auto 2md:h-[22px] text-[14px] sm:text-[12px] rounded-lg">
                          { typeTransfert=== 'cash_pickup' ? 'À retirer' : 'En cours'}
                        </div>
                       : listTransaction?.status ==='canceled' ? (
                        <div className="bg-[#FED7D8] text-[#EC1C24] flex items-center justify-center w-auto p-2 h-[35px] 2md:h-[22px] text-[14px] sm:text-[12px] rounded-lg">
                          Annulé
                        </div>
                      ) : (
                        <></>
                      )}
                    </td>
                   
                  </tr>
                
               
              </React.Fragment>
            ))}

            {openModale && (typeTransfert==='cash_pickup' || typeTransfert==='bank_account')
               &&
               <ModalHistoryTransfert
                  titreModal='Historique de transfert'
                  isOpen={openModale}
                  closeModal={closeModalHistoryTransfert}
                  beneficiaire={`${infoTransfert?.recipient?.personalInfo?.firstName} ${' '} ${infoTransfert
                    ?.recipient?.personalInfo?.lastName}`}
                  montantEnvoye={infoTransfert?.amount?.amountToSend}
                  montantRecevoir={infoTransfert.amount.amountToRecieve}
                  currency={infoTransfert.amount?.destinationCurrency.code}
                  taux={infoTransfert.amount?.fxRateCustomer}
                  frais={infoTransfert.amount.commission}
                  pointsCollecte={infoTransfert?.partner?.storeInfo?.name}
                  date={formatDate(infoTransfert?.createdAt)}
                  distributionChannel={infoTransfert?.distributionChannel}
                  status={infoTransfert.status}
                 codeRetrait={infoTransfert?.partnerCode}
                />
               
                }
              </tbody>

        </table>
   
  )
}

export default HistoryTable
